import SkuHelper from "./skuHelper";
import SkuDataSet from "../components/data/UnidadeArmazenamentoDataSet";
import CentroDataset from "../components/data/CentroDataset";
import ParceiroDataset from "../components/data/parceiroDataset";

let intervalId: any;

if (JSON.parse(String(localStorage.getItem("UsuarioCache")))) {
  intervalId = setInterval(verifyAndUpdateCacheWhenNeeds, 1000 * 60 * 10);
}
const keys: String[] = ["AutUser",
  "Token",
  "CentroVirtualCache",
  "UnidadeArmazenamentoCache",
  "ParceiroCache",
  "ParceiroSelecionado",
  "CodigoFornecedorSAPSelecionado",
  "ContratoSelecionado",
  "IdParceiroSelecionado",
  "GrupoParceiroSelecionado"]

export const hasInCache = (key: string): boolean => {
  let result: Boolean = false;
  var _has;
  keys.map((item: String) => {
    if (item === key)
      result = true;
    return result;
  });

  if (result)
    _has = localStorage.getItem(key);
  else {
    // eslint-disable-next-line no-throw-literal
    result = false;
    _has = "";
  }
  return (result === true && _has !== null && _has.trim().length !== 0);

}

export function stopInterval() {
  clearInterval(intervalId);
}

async function verifyAndUpdateCacheWhenNeeds() {
  verifyForSku();
  verifyForCentro();
  verifyForParceiro();
}

async function verifyForSku() {
  const skuHelper = new SkuHelper()
  const skuDataSet = new SkuDataSet()

  if(skuHelper.listaSku.length != await skuDataSet.ListarQuantidadeDeSkus()){
    updateSkuDataCache(skuDataSet);
  }
}

async function verifyForCentro() {
  const centroDataSet = new CentroDataset()

  if(await centroDataSet.ListarQuantidadeDeCentroVirtual() != (centroDataSet.ListarFromCache()?.length || 0)){
    updateCentroDataCache(centroDataSet);
  }
}

async function verifyForParceiro() {
  const parceiroDataSet = new ParceiroDataset()

  if(parceiroDataSet){
    if(await parceiroDataSet.ListarQuantidadeDeParceiro() != (parceiroDataSet.ListarFromCache()?.length || 0)){
      updateParceiroDataCache(parceiroDataSet);
    }
  }
}

function updateSkuDataCache(skuDataSet: SkuDataSet) {
  console.log("sku cache list was updated!");
  skuDataSet.ListarAtivos().then((result) => {
    skuDataSet.LimparListaDoCache();
    skuDataSet.AdicionarListaAoCache(result);
  })
}

function updateCentroDataCache(centroDataSet: CentroDataset) {
  console.log("centro cache list was updated!");
  centroDataSet.ListarAtivos().then((result) => {
    centroDataSet.LimparListaDoCache();
    centroDataSet.AdicionarListaAoCache(result);
  })
}

function updateParceiroDataCache(parceiroDataSet: ParceiroDataset) {
  console.log("parceiro cache list was updated!");
  parceiroDataSet.ListarAtivos().then((result) => {
    parceiroDataSet.LimparListaDoCache();
    parceiroDataSet.AdicionarListaAoCache(result);
  })
}